import { PartnerFlagRequestAction } from 'clickNgo/configs/profiling/partnerFlag'
import { IPartnerFlag } from 'clickNgo/entities/partner/models/partnerFlag'
import { Translation } from 'cng-common/features/translations/components/translation'

import { partnerFlagsTranslation } from '../../../../../translation'
import { DEFAULT_DATE } from '../configs'

interface IValidatePartnerFlagParams {
  partnerFlag: IPartnerFlag
  endDate: Date
}

export const validatePartnerFlag = ({
  partnerFlag,
  endDate = DEFAULT_DATE,
}: IValidatePartnerFlagParams) => {
  const isNewRequest = partnerFlag.action === PartnerFlagRequestAction.Add
  const isPast =
    partnerFlag.startDate.setHours(0, 0, 0, 0) >= endDate.setHours(0, 0, 0, 0) ||
    endDate.setHours(0, 0, 0, 0) < DEFAULT_DATE.setHours(0, 0, 0, 0)
  const isPresent = endDate.setHours(0, 0, 0, 0) === DEFAULT_DATE.setHours(0, 0, 0, 0)
  const isDeleteRequestDate = endDate.setHours(0, 0, 0, 0) === DEFAULT_DATE.setHours(0, 0, 0, 0)
  const isModified = endDate.setHours(0, 0, 0, 0) !== partnerFlag.endDate.setHours(0, 0, 0, 0)
  const isApplyDisabled = !isModified || isPast || (isDeleteRequestDate && isNewRequest)

  const messages = []

  if (isModified) {
    if (isPast) {
      messages.push(<Translation text={partnerFlagsTranslation.notification.canNotBePast} />)
    }

    if (isPresent && isNewRequest) {
      messages.push(<Translation text={partnerFlagsTranslation.notification.canNotBePresent} />)
    }

    if (isDeleteRequestDate && !isNewRequest) {
      messages.push(<Translation text={partnerFlagsTranslation.notification.deleteRequestDate} />)
    }
  }

  return { isApplyDisabled, isModified, messages }
}
